import Api from "../axios";

export const getLeaveLogList = async ({ employee_id, startDate, endDate }) => {
  return Api.get(
    `/leave_logs_list?employee_id=${employee_id}&start_date=${startDate}&end_date=${endDate}`
  );
};
